<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Alerts from './alerts'

import axios from 'axios'

export default {
	page: {
		title: 'All Alerts',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Alerts },
	data() {
		return {
			title: 'All Alerts',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'All Alerts',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Alerts :source="'/pan/xdr/incidents?include=incident.alerts'"/>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>